import styles from './ConsentTypeStep.module.css';

function ConsentTypeStep({ onSelectSelf, onSelectGuardian }) {
  return (
    <div className={styles.wrap}>
      <p className={styles.title}>동의자 선택</p>
      <p className={styles.desc}>
        동의서를 작성하시는 분은 누구인가요?
      </p>
      <div className={styles.btnGroup}>
        <button className={`${styles.btn} ${styles.selfBtn}`} onClick={onSelectSelf}>
          어르신 본인 직접 동의
        </button>
        <button className={`${styles.btn} ${styles.guardianBtn}`} onClick={onSelectGuardian}>
          보호자 대리 동의
        </button>
      </div>
    </div>
  );
}

export default ConsentTypeStep;
